import { getBootstrapData } from "@swa-ui/bootstrap";
import { swaDate } from "@swa-ui/date";
import i18n from "@swa-ui/locale";
import { filter } from "@swa-ui/object";

const DEFAULT_LABEL = "";
const DEFAULT_SIZE = "xsmall";
const DEFAULT_STYLE_TYPE = "primary";

const getUrgencyTriggerRules = (themeName, urgencyTriggerOverride) => {
  const urgencyTriggerBootstrapData = getBootstrapData("urgency-trigger") ?? {};

  return (
    urgencyTriggerOverride ??
    urgencyTriggerBootstrapData[themeName] ??
    urgencyTriggerBootstrapData.DEFAULT ??
    {}
  );
};

export const getUrgencyTriggerTheme = (endDate, startDate, themeName, urgencyTriggerOverride) => {
  const promotionEndDate = swaDate(endDate).endOf("day");
  const promotionStartDate = swaDate(startDate).startOf("day");
  const promotionEndDayOfWeek = promotionEndDate.format("dddd");
  const promotionEndDaysLeft = Math.round(promotionEndDate.diff(swaDate(), "day"));
  const promotionEndDateFormatted = promotionEndDate.format("MM/DD/YYYY");
  const promotionEndHoursLeft = Math.round(promotionEndDate.diff(swaDate(), "hour"));
  const promotionEndMinutesLeft = Math.round(promotionEndDate.diff(swaDate(), "minute"));
  const promotionStartHoursLeft = Math.round(promotionStartDate.diff(swaDate(), "hour"));
  const promotionStartDateFormatted = promotionStartDate.format("MM/DD/YYYY");
  const promotionStartDaysLeft = promotionStartDate.diff(swaDate().startOf("day"), "days");
  const urgencyTrigger = getUrgencyTriggerRules(themeName, urgencyTriggerOverride);
  const relevantUrgencyEntries = Object.entries(
    filter(
      urgencyTrigger,
      ({ rule }) =>
        (rule?.unit === "minutes" && promotionEndMinutesLeft <= parseInt(rule?.past)) ||
        (promotionEndMinutesLeft > 0 && promotionEndMinutesLeft <= parseInt(rule?.remaining)) ||
        (rule?.unit === "hours" &&
          promotionEndHoursLeft > 0 &&
          promotionEndHoursLeft <= parseInt(rule?.remaining)) ||
        (rule?.unit === "days" &&
          promotionEndDaysLeft > 0 &&
          promotionEndDaysLeft <= parseInt(rule?.remaining)) ||
        (rule?.unit === "days" && promotionStartHoursLeft >= parseInt(rule?.startRemaining)) ||
        rule?.unit === "default"
    )
  );
  const {
    i18nLabel = DEFAULT_LABEL,
    size = DEFAULT_SIZE,
    styleType = DEFAULT_STYLE_TYPE,
  } = relevantUrgencyEntries?.[0]?.[1] ?? {};

  return {
    label: i18n(i18nLabel, {
      promotionEndDateFormatted,
      promotionEndDayOfWeek,
      promotionEndDaysLeft,
      promotionEndHoursLeft,
      promotionEndMinutesLeft,
      promotionStartDateFormatted,
      promotionStartDaysLeft,
    }),
    size,
    styleType,
  };
};
